<template>
<div class="min-h-screen bg-gray-200">
  <div class="relative pb-24 overflow-hidden">
    <!-- On: "bottom-0", Off: "inset-y-0" -->
    <div class="absolute flex justify-center inset-x-0 left-1/2 transform -translate-x-1/2 w-full overflow-hidden lg:inset-y-0" aria-hidden="true">
      <div class="flex-grow bg-gray-200"></div>
    </div>
    <header class="relative py-4">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      </div>
    </header>
  </div>

  <main class="relative -mt-32">
    <div class="max-w-screen-xl mx-auto pb-4 lg:pb-16 lg:px-8">
      <router-view></router-view>
    </div>
  </main>
  <div v-if="$store.state.data.msg !== undefined" aria-live="assertive" class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start">
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
      <div class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
        <div class="p-4">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <!-- Heroicon name: outline/check-circle -->
              <svg v-if="$store.state.data.msgtype === 'error'" class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>

              <svg v-else class="h-6 w-6 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>

            </div>
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="text-sm font-medium text-gray-900">
                {{$store.state.data.msg}}
              </p>
            </div>
            <div class="ml-4 flex-shrink-0 flex">
              <button @click="emptyNotification" class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                <span class="sr-only">Close</span>
                <!-- Heroicon name: solid/x -->
                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'App',
  created() {
    setTimeout(this.emptyNotification, 15000)
  },
  mounted() {
    this.sendTimestamp()
    setInterval(this.sendTimestamp, 10000)
  },
  methods: {
    emptyNotification() {
      this.$store.commit('setState', {msg: undefined})
    },
    sendTimestamp() {
      this.$http.post('/set_timestamp', {timestamp: Date.now()})
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        });
    }
  }
}
</script>
